export const AUTO_SAVE_INTERVAL = 30000;
export const AUTO_SAVE_CLEAR_DELAY = 2000;

export const DOMAIN_SETTINGS_URL = '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=landingpage.settings.title';
export const UNLAYER_BUILDER_CUSTOMIZATION_HELP_URL = 'https://help.keap.com/help/broadcast-customize-a-broadcast-new-email-builder';

export const SOURCES = Object.freeze({
    CAMPAIGN: 'CAMPAIGN',
    BROADCAST: 'BROADCAST',
});

export const UNLAYER_EMAIL_BROADCAST_WIZARD_STAGE_INDEXES = {
    TEMPLATE: 0,
    CREATE: 1,
};

export const EMAIL_BUILDER_UNLAYER_VERSION = '1.259.0';

export const customToolsUri = 'https://storage.googleapis.com/is-unlayer-tools.appspot.com/builds/keap-unlayer-email-tools-3.10.27.js';